module.exports = __webpack_public_path__ + "img/brand-1.7bfab236.png";